<!-- <script>
    import {onMount} from 'svelte';  

    import {getNextInputId} from '../../helper/UIHelper';  

    export let model;
    export let list;
    export let inline;
    export let itemClass= "";

    let className = "";
    export {className as class};
    let uid = getNextInputId();


</script>

<div class="relative {className}" class:inline-block={inline}>
   {#each list as item, i}
        <label for="{uid}_{i}" class:block={!inline} class={itemClass}>
            <input id="{uid}_{i}" type="radio" bind:group={model} value={item.value} name={uid}>
                {item.text}
        </label>
    {/each}
</div> -->

<script>
	import { getContext } from 'svelte';
    import {getNextNumber} from '../../helper/UIHelper';  
    
    const uid_2 = getNextNumber();
	const uid = getContext('input_uid');
    export let model;
    let className = "";
    let itemVal = null;
    export {className as class};
    export {itemVal as value};
    export {model as group};

</script>

<div>
  <label for="{uid}_{uid_2}" class={className}>
        <input id="{uid}_{uid_2}" bind:group={model} type="radio" value={itemVal} name={uid}>
        <slot></slot>
    </label>
</div>